import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "@/lib/utils"

const inputVariants = cva("h-input", {
  variants: {
    size: {
      sm: "h-input--sm",
      xs: "h-input--xs",
      lg: "h-input--lg",
    },
    fullWidth: {
      true: "h-input--block",
    },
  },
})

export interface InputProps extends Omit<React.ComponentProps<"input">, "size">, VariantProps<typeof inputVariants> {
  rightElement?: React.ReactNode
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, size, fullWidth, rightElement, ...props }, ref) => {
    const input = (
      <input
        type={type}
        className={cn(inputVariants({ size, fullWidth }), className)}
        ref={ref}
        {...props}
        data-1p-ignore
        data-bwignore
      />
    )

    if (rightElement) {
      return (
        <div className="h-field">
          {input}
          <div className="h-field__append h-field__append--tight">{rightElement}</div>
        </div>
      )
    }

    return input
  },
)
Input.displayName = "Input"

export { Input }
